import { render, staticRenderFns } from "./PasswordResetRequest.vue?vue&type=template&id=81b1abfe&scoped=true"
import script from "./PasswordResetRequest.vue?vue&type=script&lang=ts"
export * from "./PasswordResetRequest.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetRequest.vue?vue&type=style&index=0&id=81b1abfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b1abfe",
  null
  
)

/* custom blocks */
import block0 from "./PasswordResetRequest.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports